const Layer = ({ children,...props }) => {
  return (
    <div style={{ position: "absolute", width: "100%", height: "100%" }} {...props}>
      {children}
    </div>
  );
};

export default Layer;
